import type {Elements, IContentItem} from '@kontent-ai/delivery-sdk'
import {useRouter} from 'next/router'
import {ButtonIcons} from '@/components/button-icons/button-icon'
import {Button} from '@/products/flexible-web-toolkit/components/button/button'
import {spacing} from '@/products/flexible-web-toolkit/styles'
import type {Block} from '@/services/kontent-ai/types'
import {colorWithFallback} from '@/utilities/hooks/color-with-fallback'

export type CTAButtonEmailContentItem = IContentItem<{
	text: Elements.TextElement
	emailRecipient: Elements.TextElement
	emailCc: Elements.TextElement
	emailSubject: Elements.TextElement
	emailBody: Elements.TextElement
	variant: Elements.MultipleChoiceElement
	icon: Elements.MultipleChoiceElement
	snippetSpacingSpacing: Elements.MultipleChoiceElement
	brandColor: Elements.CustomElement
}>

export const CTAButtonEmailBlock: Block<CTAButtonEmailContentItem> = ({
	block,
	page,
}) => {
	const {locale} = useRouter()
	const spacingChoice =
		spacing[
			block.elements.snippetSpacingSpacing[0]
				?.codename as keyof typeof spacing
		]
	// eslint-disable-next-line @typescript-eslint/no-unnecessary-condition -- not unnecessary, spacingChoice may be null
	const componentSpacing = !spacingChoice ? spacing.default : spacingChoice

	const emailCc = block.elements.emailCc
	const emailSubject = block.elements.emailSubject
	const emailBody = block.elements.emailBody
	const emailRecipient = block.elements.emailRecipient

	const cc = encodeURIComponent(emailCc)
	const subject = encodeURIComponent(emailSubject)
	const body = encodeURIComponent(emailBody)

	// Construct the mailto link
	const href = `mailto:${emailRecipient}?cc=${cc}&subject=${subject}&body=${body}`

	const {colorId: finalColorId} = colorWithFallback({
		blockColor: block.elements.brandColor,
		blockColorLegacy: block.elements.variant,
		pageConfig: page.elements.config[0],
		fallbackColorId: 'primary',
	})

	return (
		<div className={`${componentSpacing} container-narrow text-center`}>
			<Button
				as="a"
				data-kontent-element-codename="text"
				href={href}
				icon={
					ButtonIcons[
						block.elements.icon[0]?.name as keyof typeof ButtonIcons
					]
				}
				locale={locale}
				variant={finalColorId}
			>
				{block.elements.text}
			</Button>
		</div>
	)
}
